export default __webpack_public_path__ + "static/media/self.58fdd807.png";